import { storage } from '@/utils';
import { useContext } from 'react';
import { UserContext } from './UserContext';
import { UserHttp } from '@/services';
import { envConfig } from '@/configs';
import { STORAGE_CART_KEY } from '@/configs/constants';
import { withBasePath } from '@/utils/basePath';

export const useUserContext = () => useContext(UserContext);

export const logout = async (username: string) => {
  storage.removeMultiple([
    'TOKEN',
    'REFRESH_TOKEN',
    'PROFILE',
    'SEENED_MESSAGES',
    'reserves-list',
    'smd-survey-data',
    STORAGE_CART_KEY,
  ]);
  let logoutURL = envConfig?.onPremise?.core?.auth?.casLogoutURL;
  console.log('logoutURL', logoutURL);
  try {
    if (!username) return;
    await UserHttp.logout(username);
    if (!logoutURL || logoutURL === '') {
      logoutURL = withBasePath('/');
    }
  }
  catch (_e) {
  }
  window.location.href = logoutURL;
};
